import type { City } from '@/api/domains/cities.types';
import type { Option } from '@/pages/auth/sign-up/forms/types';

export const isCity = (option: Option): option is City => {
  return option && 'settlement_type' in option;
};
